module.exports = __webpack_public_path__ + "img/weixinDiaolog.17e862e4.png";